import { login } from "../api/login";

// Function to perform the login operation
const performLogin = async (): Promise<any> => {

    try {
        // Make the API request to login (the API identifies the user from the token)
        const apiResults = await login();

        // Log the API results for debugging purposes
        console.log(apiResults);

        // Check if the API results are not returned or empty, throw an error
        if (!apiResults) { 
            throw new Error("Login Failed.");
        }

        // Store the results from the API response
        const authData = apiResults;

        // Log the authData for debugging
        console.log(authData);

        // Return the authData to be used elsewhere
        return authData;

    } catch (err) {
        // Log any errors encountered during the login process
        console.error("Error in performLogin", err);

        // Throw the error for handling in calling code
        throw err;
    }

};

// Export the performLogin function to be used in other parts of the application
export { performLogin };
